<template>
  <div class="card-container">
    <el-page-header
      @back="$router.go(-1)"
      content="参数配置"
      class="commonTitle"
    ></el-page-header>
    <common-top-form
      :model="formModel"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      :submitService="submitService"
      :submitData="submitData"
    >
      <select-organs v-model="formModel.tatId"></select-organs>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="tatName"
        label="机构名称"
        :formatter="formatterTableData"
        min-width="130"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="repayFeeRate"
        label="还款消费概率%"
        :formatter="formatterTableData"
        min-width="130"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="repayFee"
        label="还款消费比例%"
        :formatter="formatterTableData"
        min-width="130"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="repayRate"
        label="还款代付概率%"
        :formatter="formatterTableData"
        min-width="130"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="quickPayFeeRate"
        label="快捷消费概率%"
        :formatter="formatterTableData"
        min-width="130"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="quickPayFee"
        label="快捷消费比例%"
        :formatter="formatterTableData"
        min-width="130"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="quickPayRate"
        label="快捷代付概率%"
        :formatter="formatterTableData"
        min-width="130"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="withdrawRate"
        label="提现概率%"
        :formatter="formatterTableData"
        min-width="130"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="memLevelRate"
        label="升级缴费概率%"
        :formatter="formatterTableData"
        min-width="130"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="authRate"
        label="认证抽样概率"
        :formatter="formatterTableData"
        min-width="130"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="authRetryNum"
        label="单笔认证最大次数"
        :formatter="formatterTableData"
        min-width="140"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="quickPayJumpRate"
        label="快捷跳转概率"
        :formatter="formatterTableData"
        min-width="130"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="quickPayJumpRateClone"
        label="快捷跳转克隆"
        :formatter="formatterTableData"
        min-width="130"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="repayJumpRate"
        label="还款跳转概率"
        :formatter="formatterTableData"
        min-width="140"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" fixed="right" min-width="100">
        <template slot-scope="scope">
          <el-button type="text" @click="openAddDialog(scope.row)"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="formDialogTitle"
      :model="dialogModel"
      :rules="dialogRules"
      :dialogService="dialogService"
      :submitData="dialogData"
      @success="dialogSuccess"
      @close="dialogClose"
      labelWidth="130px"
    >
      <div class="line-bottom">
        <select-organs
          v-model="dialogModel.tatId"
          :selectValue="dialogModel.tatId"
          selectProp="tatId"
          :organDisabled="Boolean(infoId)"
          :needAll="false"
        ></select-organs>
      </div>
      <div class="line-bottom">
        <el-form-item label="还款消费概率" prop="repayFeeRate">
          <el-input-number
            v-model="dialogModel.repayFeeRate"
            :precision="2"
            :step="0.1"
            :controls="false"
            :min="0"
            :max="100"
            controls-position="right"
          ></el-input-number>
          <span class="unit">%</span>
        </el-form-item>
        <el-form-item label="还款消费比例" prop="repayFee">
          <el-input-number
            v-model="dialogModel.repayFee"
            :precision="2"
            :step="0.1"
            :controls="false"
            :min="0"
            :max="100"
            controls-position="right"
          ></el-input-number>
          <span class="unit">%</span>
        </el-form-item>
      </div>
      <div class="line-bottom">
        <el-form-item label="还款代付概率" prop="repayRate">
          <el-input-number
            v-model="dialogModel.repayRate"
            :precision="2"
            :step="0.1"
            :controls="false"
            :min="0"
            :max="100"
            controls-position="right"
          ></el-input-number>
          <span class="unit">%</span>
        </el-form-item>
      </div>
      <div class="line-bottom">
        <el-form-item label="快捷消费概率" prop="quickPayFeeRate">
          <el-input-number
            v-model="dialogModel.quickPayFeeRate"
            :precision="2"
            :step="0.1"
            :controls="false"
            :min="0"
            :max="100"
            controls-position="right"
          ></el-input-number>
          <span class="unit">%</span>
        </el-form-item>
        <el-form-item label="快捷消费比例" prop="quickPayFee">
          <el-input-number
            v-model="dialogModel.quickPayFee"
            :precision="2"
            :step="0.1"
            :controls="false"
            :min="0"
            :max="100"
            controls-position="right"
          ></el-input-number>
          <span class="unit">%</span>
        </el-form-item>
      </div>
      <div class="line-bottom">
        <el-form-item label="快捷代付概率" prop="quickPayRate">
          <el-input-number
            v-model="dialogModel.quickPayRate"
            :precision="2"
            :step="0.1"
            :controls="false"
            :min="0"
            :max="100"
            controls-position="right"
          ></el-input-number>
          <span class="unit">%</span>
        </el-form-item>
      </div>
      <div class="line-bottom">
        <el-form-item label="提现概率" prop="withdrawRate">
          <el-input-number
            v-model="dialogModel.withdrawRate"
            :precision="2"
            :step="0.1"
            :controls="false"
            :min="0"
            :max="100"
            controls-position="right"
          ></el-input-number>
          <span class="unit">%</span>
        </el-form-item>
      </div>
      <div class="line-bottom">
        <el-form-item label="升级缴费概率" prop="memLevelRate">
          <el-input-number
            v-model="dialogModel.memLevelRate"
            :precision="2"
            :step="0.1"
            :controls="false"
            :min="0"
            :max="100"
            controls-position="right"
          ></el-input-number>
          <span class="unit">%</span>
        </el-form-item>
      </div>
      <div class="line-bottom">
        <el-form-item label="认证抽样概率" prop="authRate">
          <el-input-number
            v-model="dialogModel.authRate"
            :precision="2"
            :step="0.1"
            :controls="false"
            :min="0"
            :max="100"
            controls-position="right"
          ></el-input-number>
          <span class="unit">%</span>
        </el-form-item>
        <el-form-item label="单笔认证最大次数" prop="authRetryNum">
          <el-input-number
            v-model="dialogModel.authRetryNum"
            :precision="2"
            :step="0.1"
            :controls="false"
            :min="0"
            controls-position="right"
          ></el-input-number>
          <span class="unit">次</span>
        </el-form-item>
      </div>
      <div class="line-bottom">
        <el-form-item label="快捷跳转概率" prop="quickPayJumpRate">
          <el-input-number
            v-model="dialogModel.quickPayJumpRate"
            :precision="2"
            :step="0.1"
            :controls="false"
            :min="0"
            :max="100"
            controls-position="right"
          ></el-input-number>
          <span class="unit">%</span>
        </el-form-item>
        <el-form-item label="快捷跳转克隆" prop="quickPayJumpRateClone">
          <el-input-number
            v-model="dialogModel.quickPayJumpRateClone"
            :precision="2"
            :step="0.1"
            :controls="false"
            :min="0"
            :max="100"
            controls-position="right"
          ></el-input-number>
          <span class="unit">%</span>
        </el-form-item>
        <el-form-item label="还款跳转概率" prop="repayJumpRate">
          <el-input-number
            v-model="dialogModel.repayJumpRate"
            :precision="2"
            :step="0.1"
            :controls="false"
            :min="0"
            controls-position="right"
          ></el-input-number>
          <span class="unit">%</span>
        </el-form-item>
      </div>
      <div class="line-bottom">
        <select-organs
          organName="目标机构"
          v-model="dialogModel.quickPayJumpRateTatId"
          :selectValue="dialogModel.quickPayJumpRateTatId"
          selectProp="quickPayJumpRateTatId"
          :needAll="false"
        ></select-organs>
      </div>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import SelectOrgans from "components/business/SelectOrgans";
import TimeRange from "service/constant/TimeRange";
import FormDialog from "../../dialog/FormDialog";
import FinanceService from "service/FinanceService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "TaxLogConfig",
  data() {
    return {
      formModel: {
        tatId: "",
      },
      tableData: [],
      submitService: FinanceService.tatTaxList,
      page: [],
      isPage: false,
      countInfo: {},
      orderTypes: [],
      formDialogTitle: "",
      dialogService: null,
      infoId: "",
      dialogModel: {
        tatId: "",
        repayFeeRate: "",
        repayFee: "",
        repayRate: "",
        quickPayFeeRate: "",
        authRate: "",
        quickPayFee: "",
        authRetryNum: "",
        quickPayRate: "",
        withdrawRate: "",
        memLevelRate: "",
        quickPayJumpRate: "",
        repayJumpRate: "",

        quickPayJumpRateClone: "",
      },
      getTatSimpleId: "",
      dialogRules: {
        tatId: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请选择机构名称"));
              } else {
                if (this.getTatSimpleId == value) {
                  return callback();
                }
                this.checkOnly(value, (res) => {
                  res.contents.checkFlag
                    ? callback(new Error("机构名称不能重复"))
                    : callback();
                });
              }
            },
          },
        ],
        quickPayJumpRateTatId: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请选择机构名称"));
              } else {
                return callback();
              }
            },
          },
        ],
      },
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  components: {
    CommonTopForm,
    CommonTable,
    SelectOrgans,
    FormDialog,
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.roleYuan.indexOf(vm.userInfo.userName) < 0) {
        vm.showWarming("您暂无该权限");
        vm.$router.back(-1);
      }
    });
  },
  computed: {
    submitData() {
      const params = {
        tatSimpleId: this.formModel.tatId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return params;
    },
    dialogData() {
      return {
        tatSimpleId: this.dialogModel.tatId,
        repayFeeRate: this.dialogModel.repayFeeRate,
        repayFee: this.dialogModel.repayFee,
        repayRate: this.dialogModel.repayRate,
        quickPayFeeRate: this.dialogModel.quickPayFeeRate,
        authRate: this.dialogModel.authRate,
        quickPayFee: this.dialogModel.quickPayFee,
        authRetryNum: this.dialogModel.authRetryNum,
        quickPayRate: this.dialogModel.quickPayRate,
        withdrawRate: this.dialogModel.withdrawRate,
        memLevelRate: this.dialogModel.memLevelRate,
        quickPayJumpRate: this.dialogModel.quickPayJumpRate,
        repayJumpRate: this.dialogModel.repayJumpRate,

        quickPayJumpRateClone: this.dialogModel.quickPayJumpRateClone,
        quickPayJumpRateTatId: this.dialogModel.quickPayJumpRateTatId,
        id: this.infoId,
      };
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(data) {
      const result = data.contents;
      this.tableData = result.records;
      this.page.currentPage = result.current;
      this.page.total = result.total;
      this.page.pageSize = result.size;
    },
    openAddDialog(item) {
      this.$refs.formDialog.open();
      this.infoId = item ? item.id : "";
      this.getTatSimpleId = "";
      if (this.infoId) {
        this.dialogModel = JSON.parse(JSON.stringify(item));
        this.getTatSimpleId = this.dialogModel.tatId;
      }
      this.formDialogTitle = this.infoId ? "修改" : "添加";
      this.dialogService = this.infoId
        ? FinanceService.tatTaxEdit
        : FinanceService.tatTaxAdd;
    },
    dialogSuccess(data) {
      this.doCheck(data, (data) => {
        this.showSuccess(data.respMsg);
        this.$refs.formDialog.closeDialog();
        this.getList();
      });
    },
    checkOnly(val, onSuccess) {
      const params = {
        tatSimpleId: val,
      };
      this.doLoad(
        FinanceService.checkOnly,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            onSuccess && onSuccess(res);
          });
        },
        "信息获取失败"
      );
    },
    dialogClose() {
      this.dialogModel = {
        id: "",
        repayFeeRate: "",
        repayFee: "",
        repayRate: "",
        quickPayFeeRate: "",
        authRate: "",
        quickPayFee: "",
        authRetryNum: "",
        quickPayRate: "",
        withdrawRate: "",
        memLevelRate: "",
        quickPayJumpRate: "",
        repayJumpRate: "",

        quickPayJumpRateClone: "",
        quickPayJumpRateTatId: "",
      };
    },
  },
};
</script>

<style scoped>
.unit {
  margin-left: 15px;
}

.line-bottom {
  border-bottom: 1px dashed #e6e6e6;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/TaxLogConfig.vue